import MapContainer from "@/components/map-container/MapContainer";

import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { useWindowSize } from "@/hooks/use-window-resize";
import { useResponsiveZoom } from "../../hooks/use-responsive-zoom";
import { calcPosition } from "../../helpers/map-card-zoom-helpers";
import { t } from "i18next";
import { MAP_CARD_EXTEND } from "@/components/map-container/map-constant";
import { mergeForecastDataWithStation } from "@/helpers/weather-data-station";
import { getCurrentLanguage } from "@/helpers/get-current-langage";

import "./style.scss";

export const MapCard = () => {
	const width = useWindowSize();

	const lang = getCurrentLanguage();
	const zoom = useResponsiveZoom(width);

	const { selectedDate, dayliesData, isLoading, stations, error } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				stations: store.getCityState(),
				selectedDate: store.getDateSelectedCityState(),
				...store.getDailyForecast(),
			};
		},
	);

	const mergedForecastDataWithStation = mergeForecastDataWithStation(
		stations.cityData,
		dayliesData,
		lang === "ar",
	);

	return (
		<div className="map-card">
			{isLoading && (
				<div className="status-overlay">
					<div className={`status-box ${error ? "error" : ""}`}>
						{isLoading && (
							<>
								<div className="spinner"></div>
								<p>{t("loading")}</p>
							</>
						)}

						{error && (
							<>
								<p>{t("fetchError")}</p>
							</>
						)}
					</div>
				</div>
			)}

			<MapContainer
				showRegionStroke={false}
				zoom={zoom}
				position={calcPosition(width)}
				showStationLabelAndImage={true}
				filter={"present_weather"}
				controls={[]}
				height={570}
				allowInteraction={true}
				forecastDataWithStations={{
					data: mergedForecastDataWithStation,
					show: true,
					selectedDate: selectedDate,
				}}
				extend={MAP_CARD_EXTEND}
			/>
		</div>
	);
};

export default MapCard;
